module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-1-Australia-Landing-Page.54f36833.jpg";